import { CarBatteryIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Battery = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <CarBatteryIcon {...rest} size={Sizes[size]} color={fill} />;
};

Battery.displayName = 'Battery';
